// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EmployeeModel_EmployeeFragment = { __typename?: 'Employee', id: string, isAdmin?: boolean | null, tier: Types.EmployeeTier, idpID?: string | null, workosDirectoryUserID?: string | null, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string }, assignedHouseholds?: Array<{ __typename?: 'Household', id: string, displayName: string, primaryRelationshipOwner: { __typename?: 'User', id: string, displayName: string } }> | null, teams?: Array<{ __typename?: 'Team', id: string, name: string }> | null, roles?: Array<{ __typename?: 'Role', id: string }> | null };

export type GetEmployeeQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EmployeeWhereInput>;
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeConnection', edges?: Array<{ __typename?: 'EmployeeEdge', node?: (
        { __typename?: 'Employee' }
        & EmployeeModel_EmployeeFragment
      ) | null } | null> | null } };

export type EmployeeForm_RoleFragment = { __typename?: 'Role', id: string, isDefault: boolean, displayName: string, kind: Types.RoleKind, capabilities?: Array<{ __typename?: 'Capability', id: string, displayName: string, authzedRelationName: string }> | null };

export type GetEmployeeRoleOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEmployeeRoleOptionsQuery = { __typename?: 'Query', roles: { __typename?: 'RoleConnection', edges?: Array<{ __typename?: 'RoleEdge', node?: (
        { __typename?: 'Role' }
        & EmployeeForm_RoleFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetEmployee: 'GetEmployee' as const,
    GetEmployeeRoleOptions: 'GetEmployeeRoleOptions' as const
  },
  Fragment: {
    EmployeeModel_Employee: 'EmployeeModel_Employee' as const,
    EmployeeForm_Role: 'EmployeeForm_Role' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EmployeeModel_EmployeeFragmentDoc = gql`
    fragment EmployeeModel_Employee on Employee {
  id
  isAdmin
  tier
  idpID
  workosDirectoryUserID
  user {
    id
    email
    firstName
    lastName
  }
  assignedHouseholds {
    id
    displayName
    primaryRelationshipOwner {
      id
      displayName
    }
  }
  teams {
    id
    name
  }
  roles {
    id
  }
}
    `;
export const EmployeeForm_RoleFragmentDoc = gql`
    fragment EmployeeForm_Role on Role {
  id
  isDefault
  displayName
  kind
  capabilities {
    id
    displayName
    authzedRelationName
  }
}
    `;
export const GetEmployeeDocument = gql`
    query GetEmployee($where: EmployeeWhereInput) {
  employees(where: $where) {
    edges {
      node {
        ...EmployeeModel_Employee
      }
    }
  }
}
    ${EmployeeModel_EmployeeFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, withFetchPolicyContext(options));
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, withFetchPolicyContext(options));
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeSuspenseQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeeRoleOptionsDocument = gql`
    query GetEmployeeRoleOptions {
  roles(where: {kindIn: [CUSTOM, ADMINISTRATOR]}) {
    edges {
      node {
        ...EmployeeForm_Role
      }
    }
  }
}
    ${EmployeeForm_RoleFragmentDoc}`;

/**
 * __useGetEmployeeRoleOptionsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeRoleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeRoleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeRoleOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeRoleOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>(GetEmployeeRoleOptionsDocument, withFetchPolicyContext(options));
      }
export function useGetEmployeeRoleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>(GetEmployeeRoleOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEmployeeRoleOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>(GetEmployeeRoleOptionsDocument, withFetchPolicyContext(options));
        }
export type GetEmployeeRoleOptionsQueryHookResult = ReturnType<typeof useGetEmployeeRoleOptionsQuery>;
export type GetEmployeeRoleOptionsLazyQueryHookResult = ReturnType<typeof useGetEmployeeRoleOptionsLazyQuery>;
export type GetEmployeeRoleOptionsSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeRoleOptionsSuspenseQuery>;
export type GetEmployeeRoleOptionsQueryResult = Apollo.QueryResult<GetEmployeeRoleOptionsQuery, GetEmployeeRoleOptionsQueryVariables>;